export enum ElectricityType {
    "", "EBEM Groen Variabel" = 64761616, "EBEM Groen Dyn@mic" = 64764926, "EBEM Groen B@sic +" = 64764333
}